import { RemoveBtn } from '@webapp/common/assets/icons/remove';
import { useConfirmDeleteFiles } from '@webapp/common/components/popups/confirm-file-delete';

import css from './stat.css';

export const CountAndDelete: FC<{
    filesCount: number;
    surveyId: number;
    withFilters: boolean;
    isPublic?: boolean;
}> = ({ filesCount, surveyId, withFilters, isPublic }) => {
    const { element, show } = useConfirmDeleteFiles(null, surveyId, withFilters);

    return (
        <div className={css.stat}>
            {element}
            <div className={css.amount}>{filesCount}</div>
            <div className={css.label}>файлов в архиве</div>
            {!isPublic && (
                <div className={css.remove}>
                    <RemoveBtn color='white' onClick={show} />
                </div>
            )}
        </div>
    );
};
